/* eslint-disable */
import React, { useState, useCallback, useEffect } from 'react';
import { useMediaVideos } from '../../hooks/useMediaVideos';
import './LandingMediaContent.css';

// ---------------------------------------------------------------------------
// Sub-components
// ---------------------------------------------------------------------------

/** Skeleton placeholder card */
const SkeletonCard = ({ featured = false }) => (
  <div className={`media-skeleton-card${featured ? ' featured' : ''}`}>
    <div className="media-skeleton-thumb" />
    <div className="media-skeleton-body">
      <div className="media-skeleton-line short" />
      <div className="media-skeleton-line full" />
      <div className="media-skeleton-line medium" />
      <div className="media-skeleton-line btn" />
    </div>
  </div>
);


// ---------------------------------------------------------------------------
// Main Component
// ---------------------------------------------------------------------------

const SKELETON_COUNT = 6;

const LandingMediaContent = () => {
  const { videos, loading, error } = useMediaVideos();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const handleNext = useCallback(() => {
    if (videos.length > 0) {
      setCurrentIndex((prev) => (prev + 1) % videos.length);
    }
  }, [videos.length]);

  const handlePrev = useCallback(() => {
    if (videos.length > 0) {
      setCurrentIndex((prev) => (prev - 1 + videos.length) % videos.length);
    }
  }, [videos.length]);

  useEffect(() => {
    if (videos.length <= 1 || isHovered) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % videos.length);
    }, 3000); // 3 seconds interval
    
    return () => clearInterval(interval);
  }, [videos.length, isHovered]);

  return (
    <>
      <section className="media-container" aria-labelledby="media-section-title">
        {/* ── Header ── */}
        <div className="media-header">
          <div className="media-badge">
            <span className="media-badge-dot" />
            Media Center
          </div>
          <h2 id="media-section-title" className="media-title">
            รู้จัก <span>มียา.com</span> ผ่านสื่อ
          </h2>
        </div>

        {/* ── Grid ── */}
        <div className="media-content">
          {loading ? (
            <div className="media-grid">
              {[...Array(SKELETON_COUNT)].map((_, i) => <SkeletonCard key={i} />)}
            </div>
          ) : error ? (
            <div className="media-error">
              <div className="media-error-icon">⚠️</div>
              <p>เกิดข้อผิดพลาดในการโหลดข้อมูลวิดีโอ</p>
              <div className="media-error-details">{error}</div>
            </div>
          ) : videos.length === 0 ? (
            <div className="media-empty">
              <div className="media-empty-icon">📭</div>
              <p>ยังไม่มีวิดีโอในขณะนี้</p>
            </div>
          ) : (
            <div 
              className="media-single-player-container"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {/* ปุ่มเลื่อนซ้าย */}
              <button className="carousel-nav-btn prev" onClick={handlePrev} aria-label="วิดีโอก่อนหน้า">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>

              <div className="single-video-wrapper">
                <iframe
                  src={`https://www.youtube.com/embed/${videos[currentIndex].video_id}?autoplay=0&rel=0&modestbranding=1`}
                  title={videos[currentIndex].title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  loading="lazy"
                />
              </div>

              {/* ปุ่มเลื่อนขวา */}
              <button className="carousel-nav-btn next" onClick={handleNext} aria-label="วิดีโอถัดไป">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default LandingMediaContent;
